import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import BeginTheDialogue from "./sections/BeginTheDialogue";
import OurLocalPresence from "./sections/OurLocalPresence";
import Footer from "@/reusable_sections/Footer";
import LandingPage from "./sections/LandingPage";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <LandingPage />
        <BeginTheDialogue />
        <OurLocalPresence />
      </div>
      <Footer />
    </div>;
}